import { Cookies } from "../utils/globalImports";

const COOKIE_NAME = "rememberMeUsername";

export const setRememberMeCookie = (username: string, password: string) => {
    const credentials = JSON.stringify({ username, password });
    Cookies.set(COOKIE_NAME, credentials, { expires: 30 }); // set expiry for 30 days
};

export const getRememberMeCookie = (): { username: string; password: string } | undefined => {
    const cookie = Cookies.get(COOKIE_NAME);
    if (cookie) {
        try {
            return JSON.parse(cookie);
        } catch (e) {
            console.error("Failed to parse rememberMe cookie:", e);
        }
    }
    return undefined;
};

export const removeRememberMeCookie = () => {
    Cookies.remove(COOKIE_NAME);
};
